export default __webpack_public_path__ + "static/media/json.5a405ccd.svg";